/** @format */

const Account = () => import('@/views/Account');
const Activities = () => import('@/views/childrens/management/Activities');
const Assistance = () => import('@/views/childrens/management/Assistance');
const Audit = () => import('@/views/Audit');
const Billing = () => import('@/views/Billing');
const Documents = () => import('@/views/childrens/management/Documents');
const Management = () => import('@/views/Management');
const Notifications = () => import('@/views/childrens/management/Notifications');
const Payments = () => import('@/views/childrens/management/Payments');
const Persons = () => import('@/views/Persons');
const FormLusazu = () => import('@/views/childrens/guest/FormLusazu');
const FormRoedores = () => import('@/views/childrens/guest/FormRoedores');
const Support = () => import('@/views/Support');
const nuevoArticulo = () => import('@/views/nuevoArticulo.vue');

const Inicio = () => import('@/views/Inicio');

export default [
	{
		path: '/inicio',
		name: 'inicio',
		component: Inicio,
		meta: {
			title: 'Inicio',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/audit',
		name: 'audit',
		component: Audit,
		meta: {
			title: 'Auditoria',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/persons',
		name: 'persons',
		component: Persons,
		meta: {
			title: 'Personas',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/management',
		name: 'management',
		component: Management,
		meta: {
			title: 'Planificación',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
		children: [
			{
				path: 'activities',
				name: 'activities',
				component: Activities,
				meta: {
					title: 'Actividades',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'notifications',
				name: 'notifications',
				component: Notifications,
				meta: {
					title: 'Notificaciones',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'payments',
				name: 'payments',
				component: Payments,
				meta: {
					title: 'Pagos',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'documents',
				name: 'documents',
				component: Documents,
				meta: {
					title: 'Documentos',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'assistance',
				name: 'assistance-admin',
				component: Assistance,
				meta: {
					title: 'Control de asistencia',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
		],
	},
	{
		path: '/billing',
		name: 'billing',
		component: Billing,
		meta: {
			title: 'Facturación',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/account',
		name: 'account',
		component: Account,
		meta: {
			title: 'cuenta',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/nuevo-articulo',
		name: 'nuevoArticulo',
		component: nuevoArticulo,
		meta: {
			title: 'Nuevo Articulo',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/lusazu/certificate/:idLodging/work-order/:index/',
		name: 'form-certificate-lusazu',
		component: FormLusazu,
		meta: {
			title: 'Lusazu',
			layout: 'simple',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/roedores/certificate/:idLodging/work-order/:index/',
		name: 'form-certificate-roedores',
		component: FormRoedores,
		meta: {
			title: 'Lusazu',
			layout: 'simple',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/support',
		name: 'support',
		component: Support,
		meta: {
			title: 'Soporte',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
];
